<!-- Label -->
<div *ngIf="label"
  [class]="'mapfre-input-label ' + classList"
  [style.margin-top]="mt + 'px'"
  [ngClass]="{
  'primary' : noDirtyError && hasErrors || control.dirty && hasErrors
}">{{label}}
</div>
<div [ngClass]="classList"
  class="mapfre-input">
  <input [(ngModel)]="inputValue"
    [style.margin-top]="!label ? mt + 'px' : '0px'"
    name="name"
    #inputElement
    [ngClass]="{
    'disabled':disabled,
    'error': noDirtyError && hasErrors || control.dirty && hasErrors}"
    [type]="type === 'password' && showPassword ? 'text' : type"
    [attr.maxlength]="maxLength ? maxLength : null"
    [placeholder]="placeholder"
    [value]="getInputValue(inputValue)"
    [readonly]="readonly"
    [required]="required"
    [disabled]="disabled"
    (keyup)="onKeyDown($event)"
    (blur)="onInputBlur()"
    (focus)="onInputFocus()"
    (change)="onInputChange($event)"
    (paste)="onInputPaste($event)"
    [autocomplete]="autocomplete">

  <!-- Icon -->
  <div [ngClass]="{'disabled' : !inputValue}"
    *ngIf="!iconName && type == 'password'"
    class="mapfre-input__icon mapfre-input__password"
    (click)="showPassword = !showPassword">
    <img [ngClass]="{'disabled' : !inputValue}"
      *ngIf="showPassword"
      src="assets/icons/eye-show.svg"
      alt="">
    <img [ngClass]="{'disabled' : !inputValue}"
      *ngIf="!showPassword"
      src="assets/icons/eye-hide.svg"
      alt="">
  </div>

  <div [ngClass]="{'disabled' : !inputValue}"
    *ngIf="iconName"
    class="mapfre-input__icon">
    <img [ngClass]="{'disabled' : !inputValue}"
      [src]="'assets/icons/' + iconName + '.svg'"
      alt="">
  </div>

  <!-- Hint -->
  <div class="mapfre-input__hint"
    [ngClass]="{
    'visible':((noDirtyError && hasErrors) || (control.dirty && hasErrors) || showHint) && showHintErrors,
    'primary' : noDirtyError && hasErrors || control.dirty && hasErrors
  }">
    <div class="mapfre-ml-xs mapfre-fs-xxs mapfre-mt-xxs">{{errorText}}</div>
  </div>
</div>